import React, { Component } from "react";

import { Container } from "@material-ui/core";
import MaterialTable from "material-table";
import api from "services/api";

const TopupRequests = () => {
    const [datas, setDatas] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const onInit = async () => {
        setLoading(true);

        const result = await api.get('topup-requests');
        
        setDatas(result.data.data);
        setTimeout(() => {
            setLoading(false);
        }, 200);
    }

    React.useEffect(() => {
        onInit();
    }, []);

    const handleStatusChange = async (rowData, newStatus) => {
        setLoading(true);

        try {
            await api.put(`topup-requests/${rowData.id}/status`, {
                status: newStatus
            });
            // Refresh data after status update
            onInit();

            setLoading(false);
        } catch (error) {
            alert('Ops, Failed to change the status request');

            setLoading(false);
        }
    };

    return (
        <Container id="enquiry" maxWidth="xl" >
            <MaterialTable
                title="Request Topup Data"
                columns={[
                    { title: 'No', field: 'id', width: 100, render: rowData => rowData.tableData.id + 1 },
                    { 
                        title: "Name", 
                        field: "user.firstname", 
                        render: rowData => (<a href={`/user/${rowData.user_id}`}>{rowData.user.firstname} {rowData.user.lastname}</a>) 
                    },
                    { title: 'Requested at', field: 'created_at', type: 'datetime' },
                    { title: "Amount", field: "amount", render: rowData => `$${rowData.amount}` },
                    { title: 'Proof of transfer', field: 'file_transaction_receipt', render: rowData => (
                        <>
                            {!rowData.file_transaction_receipt ? <span>- No File -</span> : <a href={rowData.file_transaction_receipt} target="_blank" rel="noopener noreferrer">
                                <img src={rowData.file_transaction_receipt} width={50}/>
                            </a>}
                        </>
                        )},
                    { 
                        title: 'Status', 
                        field: 'status',
                        render: rowData => (
                            <>
                                <select
                                    value={rowData.status}
                                    onChange={(e) => handleStatusChange(rowData, e.target.value)}
                                    style={{ width: 130, padding: '5px', marginLeft: '10px' }}
                                    disabled={rowData.status === 'success' || rowData.status === 'rejected'}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="success">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </>
                        )
                    },
                ]}
                options={{
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    actionsColumnIndex: -1,
                    filtering: false
                }}
                isLoading={loading}
                data={datas}
                // actions={[
                //     {
                //         icon: "supervisor_account",
                //         tooltip: "User Deatails",
                //         onClick: (e, rowData) => {
                //             window.open(`/user/${rowData.user_id}`, "_blank");
                //         },
                //     },
                // ]}
            />    
        </Container>
    );
}

export default TopupRequests;